// extracted by mini-css-extract-plugin
export default {"wrapper":"success_wrapper__w4-CU","opacity-transition":"success_opacity-transition__k5r4i"};